<template>
    <div>
        <div class="form-group">
            <span class="btn btn-info fileinput-button" v-show="!disabled || afterSubmitForm">
                <span>{{getTranslation('upload.add_file')}}</span>
                <base-uploader :options="options" v-on:fileuploadadd="onFileUploadAdd" v-on:fileuploadprogressall="onFileUploadProgressAll" v-on:fileuploaddone="onFileUploadDone" v-on:fileuploadfail="onFileUploadFail" v-on:fileuploadprocessfail="onFileUploadProcessFail"></base-uploader>
            </span>
            <!--<span class="btn btn-info fileinput-button disabled" v-show="disabled && !afterSubmitForm">
                <span>{{getTranslation('upload.add_file')}}</span>
            </span>-->
        </div>
        <div class="progress position-relative mt-1" v-if="progress">
            <div class="progress-bar bg-info" :style="{'width': `${progress}%`}">
                <span>{{`${progress}%`}}</span>
            </div>
            <span v-if="files.length">{{files[0].name}}</span>
        </div>
        <div class="form-group" v-if="files.length && !afterSubmitForm ">
            <ul class="list-group">
                <li class="list-group-item list-group-item-sm" v-for="file in files">
                    {{file.name}}
                    <span class="text-danger" v-if="file.error"><strong>{{file.error}}</strong></span>
                    <button class="btn btn-link info-link pl-0" v-if="!file.deleteUrl" @click.prevent="cancel(file)">{{getTranslation('upload.cancel')}}</button>
                    <button class="btn btn-link info-link pl-0" @click.prevent="remove(file)" v-if="file.deleteUrl">{{getTranslation('upload.delete')}}</button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import every from 'lodash/every';
    import values from 'lodash/values';
    import findIndex from 'lodash/findIndex';
    import BaseUploader from "./BaseUploader";
    import lang from '../../../lang/translator';
    import axios from 'axios';

    export default {
        components: {BaseUploader},
        props: {
            'afterSubmitForm': {
              type: Boolean,
              default() {
                return false;
              },
            },
            options: {
              type: Object,
              default() {
                return {
                  'maxChunkSize': '1000000',
                  'maxNumberOfFiles': 1,
                  'maxFileSize': '100000000',
                  'acceptFileTypes': /(\.|\/)(gif|jpe?g|png|pdf)$/i,
                  'messages': {
                    'maxNumberOfFiles': lang.get('upload.max_number_of_files'),
                    'acceptFileTypes': lang.get('upload.accept_file_types'),
                    'maxFileSize':  lang.get('upload.max_file_size'),
                    'minFileSize':  lang.get('upload.min_file_size')
                  },
                  'accept': '.jpeg,.jpg,.png,.gif,.pdf'
                };
              },
            },
        },
        data() {
            return {
                files: [],
                progress: 0,
            }
        },
        computed: {
            disabled: function() {
                return this.files.length >= this.options.maxNumberOfFiles;
            }
        },
        methods: {
            getTranslation(...args) {
                return lang.get(...args);
            },
            checkProgress() {
                if (every(this.files, (file) => file.deleteUrl || file.error)) {
                    this.progress = 0;
                }
            },
            replaceFile(file, cond = null) {
                let index = findIndex(this.files, cond || file);
                this.$set(this.files, index, file);
            },
            spliceFile(file) {
                let index = findIndex(this.files, file);
                this.files.splice(index, 1);
            },
            onFileUploadAdd(data) {
                let file = data.files[0];
                file.cancel = data.abort.bind(data);
                this.files.push(file);
                this.$emit('fileuploadadd', file);
            },
            onFileUploadProgressAll({loaded, total}) {
                this.progress = parseInt(loaded / total * 100, 10);
            },
            onFileUploadDone({result}) {
                let file = result.files[0];
                this.replaceFile(file, {name: file.original_name, size: file.size});
                this.checkProgress();
                if (file.error){
                  this.$emit('fileuploadfail', file);
                } else{
                  this.$emit('fileuploaddone', file);
                }
            },
            onFileUploadFail({files}) {
                let file = files[0];
                if (!file.error) { file.error = lang.get('upload.failed'); }
                this.replaceFile(file);
                this.checkProgress();
                this.$emit('fileuploadfail', file);
            },
            onFileUploadProcessFail({files}) {
                let file = files[0];
                this.replaceFile(file);
                this.checkProgress();
                this.$emit('fileuploadprocessfail', file);
            },
            cancel(file) {
                if (file.cancel) {
                    file.cancel();
                }
                this.spliceFile(file);
            },
            async remove(file) {
                let {data} = await axios.delete(file.deleteUrl);
                if (every(values(data))) {
                    this.spliceFile(file);
                    this.$emit('fileuploadremove', file);
                }
            }
        },
      watch: {
        afterSubmitForm: function(newVal) {
          if (newVal){
            this.files = [];
          }
        },
      },
    }
</script>



// WEBPACK FOOTER //
// src/modules/fileUpload/components/Uploader.vue